module.exports = __webpack_public_path__ + "img/SKMJ_submit4.934a84c9.jpg";